/**
 * @fileOverview Delegates events.
 * @author Selectra Front End Team
 * @version 1.0.0
 */

/**
 * @function delegate
 * @description Delegate event(s) to a parent node.
 * @arg {Object} options
 * @arg {String} options.target - The css selector to target for the event.
 * @arg {Function} options.listener - Function to use when executing the event.
 * @arg {String} [options.delegateTo='body'] - The Node to attach the event.
 * @arg {String} options.event - The event(s) to listen to. Several can be
 *     passed, using spaces as separator.
 * @requires Polyfill:Element.prototype.matches
 * @requires Polyfill:Element.prototype.closest
 */
export default function delegate( options ) {

  // Check for mandatory arguments
  if ( !options.target || !options.listener || !options.event ) {
    console.error( 'A mandatory argument was not supplied.' );
    return null;
  }

  // Default argument values for non mandatory arguments.
  const o = {
    // Default options
    delegateTo: 'body',
    // Arguments
    ...options
  };

  // Handle multiple events
  o.event.split( ' ' )
    .map( eventName => {

      // Set up event listener
      document.querySelector( o.delegateTo )
        .addEventListener( eventName, e => {

          // Populate fake event object.
          let
            eTemp = {},
            evt = {
              originalEvent: e,
              stopPropagation: e.stopPropagation.bind( e ),
              stopImmediatePropagation: e.stopImmediatePropagation.bind( e ),
              preventDefault: e.preventDefault.bind( e )
            };

          for ( let prop in e ) {
            eTemp[ prop ] = e[ prop ];
          }

          evt = { ...eTemp, ...evt };

          // Check if the event is fired by the correct element.
          if ( e.target.closest( o.target )) {
            evt.target = e.target.closest( o.target );
            evt.currentTarget = o.delegateTo;
            // Execute the listener, pass the Event to the listener and use
            //   null as this (You need to use bind to change the "this" of
            //   your listener)
            o.listener.call( null, evt );
          }

        });

    });

}
